import { Lock, Check } from 'lucide-react'
import type { PickableMatchday } from '@/hooks/usePickableMatchdays'

interface MatchdaySelectorProps {
  matchdays: PickableMatchday[]
  selectedMatchday: number
  onSelect: (matchday: number) => void
}

export function MatchdaySelector({ matchdays, selectedMatchday, onSelect }: MatchdaySelectorProps) {
  if (matchdays.length <= 1) return null

  return (
    <div className="flex gap-2 overflow-x-auto pb-1 px-4 md:px-0 md:justify-center scrollbar-hide">
      {matchdays.map((md) => {
        const isSelected = md.matchday === selectedMatchday
        const baseClasses = 'relative flex items-center gap-1 px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors shrink-0'

        let pillClasses: string
        if (isSelected) {
          pillClasses = `${baseClasses} bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900`
        } else if (md.isCompleted) {
          pillClasses = `${baseClasses} bg-zinc-100 text-zinc-400 dark:bg-zinc-800 dark:text-zinc-500`
        } else if (md.isLocked) {
          pillClasses = `${baseClasses} bg-zinc-100 text-zinc-400 dark:bg-zinc-800 dark:text-zinc-500`
        } else {
          pillClasses = `${baseClasses} bg-white text-zinc-700 border border-zinc-200 dark:bg-zinc-900 dark:text-zinc-300 dark:border-zinc-700`
        }

        return (
          <button
            key={md.matchday}
            className={pillClasses}
            onClick={() => onSelect(md.matchday)}
          >
            {md.isCompleted && (
              <Check className="w-3 h-3" />
            )}
            {md.isLocked && !md.isCompleted && (
              <Lock className="w-3 h-3" />
            )}
            <span>MD {md.matchday}</span>
            {md.hasEarlyFixture && !md.isLocked && (
              <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse" />
            )}
          </button>
        )
      })}
    </div>
  )
}
